import React from "react";

function PlanButtons() {
  return (
    <div class="col-12 col-lg-11 ml-lg-5 mt-5">
      <div class="d-flex m-auto col-md-4 col-12 flex-wrap button-section">
        <button class="btn signup-btn text-white mr-auto p-4 mb-4">
          <a href="/civwifi/#/pricing">Obtenez Internet à la maison</a>
        </button>
        <button class="btn second-btn text-white mr-auto p-4 mb-4">
          <a href="/civwifi/#/pricing">Obtenez Internet de bureau</a>
        </button>
      </div>
    </div>
  );
}
export default PlanButtons;
